// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { Environment, INSURER_DEFAULT_ID } from '@sc/data-access-models';

export const environment: Environment = {
  production: false,
  insightId: '0a3200ed-4f71-4e41-9593-076d12013987',
  auth: {
    isActive: false,
    clientId: '0oal4sr3vgEkmWAHV417',
    issuer: 'https://agr.okta.com/oauth2/default',
    redirectUri: `${window.location.origin}` + '/login/callback',
    scopes: ['openid', 'profile', 'email', 'offline_access'],
    pkce: true,
  },
  api: {
    subBaseUrlhttp: '/apigqlsub',
  },
  insurer: {
    id: INSURER_DEFAULT_ID,
    name: 'Insurer Name',
    config: {},
  },
  appName: 'aari-insurer',
  log: {
    logActivationStateManagement: true,
  },
  envName: 'dev2',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
